<template>
  <div class="d-flex">
    <base-button
      v-for="(item, index) in items"
      :key="item"
      class="groupped-button flex-fill"
      :inverse="index === value"
      @click="select(index)"
    >
      {{ item }}
    </base-button>
  </div>
</template>

<script>
export default {
  name: 'BaseButtonGroup',
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    select(index) {
      this.$emit('input', index);
    },
  },
};
</script>

<style lang="scss" scoped>
.groupped-button{
    margin: 0;

    & + &{
        border-left: none;
    }
}
</style>
